import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isLollipop } from '@bubble-ui/particle-design-versions';
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    designVersion,
    omitFirstLine,
    omitLastLine,
    previewLabel,
    sandwich,
    singleLine
  } = _ref;
  var borderRadiusType = sandwich ? 'sandwich' : 'default';
  var borderRadius = isLollipop(designVersion) && !sandwich ? 5 : designContext.get('preview/corner-radius', {
    borderRadiusType
  }).pixelValue;
  var backgroundColor = designContext.get('preview/background-color', {
    borderRadiusType
  }).toString();
  var paragraphSecondaryCorrectFootprintStyle = _objectSpread(_objectSpread({}, designContext.get('preview/link-text-style').styles()), {}, {
    WebkitFontSmoothing: 'antialiased',
    textAlign: 'left',
    wordBreak: 'break-word',
    marginBottom: -10,
    marginTop: -10
  });
  var transparent = designContext.get('colors/backgrounds/transparent').toString();
  return {
    asideStyle: {
      flexShrink: 0,
      paddingTop: !singleLine ? 9 : undefined,
      paddingBottom: !singleLine ? 4 : undefined
    },
    acceptanceMarkStyle: {
      paddingTop: !singleLine ? 6 : undefined,
      justifyContent: !singleLine ? undefined : 'center'
    },
    avatarStyle: {
      paddingTop: !singleLine ? 5 : undefined
    },
    contentStyle: {
      flexDirection: 'column',
      flexGrow: 1,
      flexShrink: 1,
      marginTop: sandwich && omitFirstLine ? 0 : -1,
      marginBottom: sandwich && omitLastLine ? 0 : -1,
      marginLeft: sandwich ? 0 : -1,
      marginRight: sandwich ? 0 : -1
    },
    iconStyle: {
      paddingTop: !singleLine ? 6 : undefined
    },
    inlineContentTextStyle: _objectSpread(_objectSpread({
      color: designContext.get('preview/content-text-color').toString(),
      marginBottom: 0,
      marginTop: 0,
      paddingBottom: 0,
      paddingTop: 0
    }, designContext.get('preview/content-text-style').styles()), {}, {
      textAlign: 'left'
    }),
    linkStyle: {
      paddingTop: singleLine ? 11 : previewLabel ? sandwich ? 6 : 9 : 5
    },
    paragraphSecondaryCorrectFootprintStyle,
    paragraphSecondaryCorrectFootprintLightStyle: _objectSpread(_objectSpread({}, paragraphSecondaryCorrectFootprintStyle), {}, {
      color: designContext.get('preview/content-text-color').toString()
    }, designContext.get('preview/content-text-style').styles()),
    previewLabelStyle: {
      flexShrink: 1,
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginTop: -5,
      marginBottom: 0
    },
    titleWrapperStyle: {
      flexShrink: 1,
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginTop: singleLine ? 1 : -5
    },
    titleStyle: _objectSpread(_objectSpread({
      marginBottom: 0,
      marginTop: 0,
      marginRight: 9,
      paddingBottom: 0,
      paddingTop: 0,
      color: designContext.get('preview/title-text-color').toString()
    }, designContext.get('preview/title-text-style').styles()), {}, {
      textAlign: 'left'
    }),
    previewGrowAndShrink: {
      flexGrow: 1,
      flexShrink: 1
    },
    previewTopStyle: {
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    rootStyle: _objectSpread({
      backgroundColor,
      position: 'relative',
      width: '100%',
      flexDirection: 'row',
      flexGrow: 1,
      alignItems: singleLine ? 'center' : undefined,
      minHeight: sandwich ? 53 : 70,
      borderStyle: 'solid',
      borderColor: designContext.get('preview/border-color', {
        borderRadiusType
      }).toString()
    }, sandwich ? {
      borderBottomWidth: omitLastLine ? 0 : 1,
      borderTopWidth: omitFirstLine ? 0 : 1,
      borderLeftWidth: 0,
      borderRightWidth: 0
    } : {
      borderRadius,
      borderWidth: 1
    }),
    spacerHorizontalMediumStyle: {
      backgroundColor: transparent,
      minHeight: 10,
      width: 15
    },
    spacerVerticalExtraSmallStyle: {
      backgroundColor: transparent,
      width: '100%',
      height: 10
    },
    spacerVerticalSmallStyle: {
      backgroundColor: transparent,
      width: '100%',
      height: 15
    },
    touchableStyle: {
      backgroundColor: transparent,
      border: 'none',
      cursor: 'pointer',
      outline: 'none',
      position: 'relative',
      width: '100%'
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map